import PageLabelBar from "../../components/common/PageLabelBar/PageLabelBar";

export default function Risorse() {
    return (
        <div className="content">
            <PageLabelBar title="Gestione Risorse" />
        </div>
    );
}